import { createUseStyles } from 'react-jss'

const border = '1px solid rgba(0,0,0,.1)'
const topbarHeight = '3rem'
const controlsWidth = '320px'

const useStyles = createUseStyles({
  topbar: {
    zIndex: 102, // one more than label studio topbar, otherwise outline is hidden
    outline: border,
    height: topbarHeight,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  prevNext: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },

  loading: {
    marginRight: '1rem',
  },

  controls: {
    width: controlsWidth,
    height: topbarHeight,
    borderLeft: border,
    display: 'flex',
  },

  titleBox: {
    height: topbarHeight,
    display: 'flex',
    alignItems: 'center',
    marginLeft: '1rem',
    paddingLeft: '1rem',
    borderLeft: border,
  },

  title: {
    fontSize: '14px',
    color: '#000',
  },

  // button with Label Studio look & feel
  button: {
    height: '100%',
    borderRadius: 0,
    boxShadow: 'none',
    fontSize: '16px',
    flex: 1,
    color: '#000',
    alignItems: 'center',
    backgroundColor: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    fontWeight: 500,
    justifyContent: 'center',
    outline: 'none',
    padding: '0 15px',
    textAlign: 'center',
    textDecoration: 'none',
    transition: 'all .1s ease',
  },

  skipButton: {
    extend: 'button',
    color: '#d00',
    backgroundColor: '#fff',
  },

  saveButton: {
    extend: 'button',
    color: '#fff',
    backgroundColor: '#09f',
  },

  infoIcon: {
    marginRight: '0.5rem',
  },

  flex1: {
    flex: 1,
  },
})

export default useStyles
